/*** AUTO-ADD FREE GIFT FOR JURA MACHINES ***/

(function() {
  const freeGiftVariantId = 10064630710593;  // Free gift variant
  const juraCollectionHandle = "jura-coffee-machines"; // Your Jura collection handle

  async function fetchProduct(handle) {
    return await fetch(`/products/${handle}.js`).then(r => r.json());
  }

  async function getCart() {
    return await fetch('/cart.js').then(r => r.json());
  }

  async function updateCart(updates) {
    return await fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ updates })
    }).then(r => r.json());
  }

  async function checkAndAddGift() {
    const cart = await getCart();
    let hasJura = false;
    let hasGift = false;

    // Check what's in the cart
    cart.items.forEach(item => {
      if (item.variant_id == freeGiftVariantId) hasGift = true;
      if (item.product_type?.toLowerCase().includes("jura") || 
          item.title.toLowerCase().includes("jura")) {
        hasJura = true;
      }
    });

    // If Jura machine is in cart and gift is not, add gift
    if (hasJura && !hasGift) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ id: freeGiftVariantId, quantity: 1 })
      });
    }

    // If NO Jura machine but gift is in cart, remove gift
    if (!hasJura && hasGift) {
      let updates = {};
      cart.items.forEach(item => {
        if (item.variant_id == freeGiftVariantId) {
          updates[item.variant_id] = 0;
        }
      });
      await updateCart(updates);
    }
  }

  // Run on cart load
  document.addEventListener("DOMContentLoaded", () => {
    checkAndAddGift();

    // Run on AJAX cart updates
    document.body.addEventListener("cart:updated", () => {
      checkAndAddGift();
    });
  });
})();
